<script setup lang="ts">
type Props = {
  src: string
}

defineProps<Props>()
</script>

<template>
  <img
    class="pointer-events-none mx-auto select-none"
    :src
    alt="pitch"
  />
</template>
